/**
 * Trạng thái hồ sơ
 */
export default {
  QuickArrange: 0, // Xếp lớp nhanh
  NormalArrange: 1, // Xếp vào lớp/Chuyển lớp
}
